import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class ConfirmacaoVagaService {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = `${environment.fullApiUrl}/confirmacao-vagas`;

  fetchTotalVagasConfirmacao(
    cicloId: number,
  ): Observable<any[]> {
    return this.http.get<any[]>(
      `${this.apiUrl}/total-vagas-modalidade/${cicloId}`,
    );
  }

  findByCicloAndGestor(cicloId: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/ciclo/${cicloId}/gestor`);
  }

  saveRascunho(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/rascunho`, data);
  }

  saveAtribuicaoIne(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/atribuir-ine`, data);
  }

  saveConfirmacao(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/confirmar`, data);
  }

  fetchVagasCiclo(cicloId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/ciclo/${cicloId}/vagas`);
  }

  fetchEquipesVagas(cicloId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/ciclo/${cicloId}/vagas-ine`);
  }

  fetchVagasAprimoramento(cicloId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/ciclo/${cicloId}/vagas-aprimoramento`);
  }

  saveConfirmacaoAprimoramento(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/confirmar-aprimoramento`, data);
  }

  uploadDocumento(formData: FormData): Observable<any> {
    return this.http.post(`${environment.fullApiUrl}/documento`, formData);
  }
}
